import { themedStyled } from 'common/styles/styletron.theme';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';

interface LoaderSelectComponentProps {
  onNextPage?: () => void;
}

export default function LoaderSelectComponent(
  props: LoaderSelectComponentProps,
) {
  const { t } = useTranslation();

  return (
    <ActionContainer onClick={props.onNextPage}>
      {t('common:load_more')}
    </ActionContainer>
  );
}

const ActionContainer = themedStyled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'blue',
  cursor: 'pointer',
  height: '100%',
  width: '100%',
  position: 'absolute',
  inset: 0,
});
